/**
 * @typedef {{ columnKey: string, label: string, enabled: boolean }} PortalFieldItem
 */

/**
 * Keep portalFields in sync when columns are added/removed/renamed.
 * @param {import('./config_schema.js').PortalConfig} config
 */
export function syncPortalFields(config) {
  const prev = config.html?.sections?.portalFields || [];
  const byKey = new Map(prev.map((item) => [item.columnKey, item]));

  config.html.sections.portalFields = (config.sheet.columns || [])
    .filter((col) => String(col.header || '').trim())
    .map((col) => {
      const existing = byKey.get(col.key);
      return {
        columnKey: col.key,
        label: String(col.header || '').trim(),
        enabled: existing ? Boolean(existing.enabled) : true
      };
    });
}

/**
 * @param {import('./config_schema.js').PortalConfig} config
 * @returns {PortalFieldItem[]}
 */
export function getEnabledPortalFields(config) {
  return (config.html?.sections?.portalFields || []).filter((item) => item.enabled);
}

/**
 * @param {import('./config_schema.js').PortalConfig} config
 */
export function hasEnabledPortalFields(config) {
  return getEnabledPortalFields(config).length > 0;
}

/**
 * @param {object[]} rowCards
 * @param {PortalFieldItem[]} enabledFields
 */
export function filterRowCardsByPortalFields(rowCards, enabledFields) {
  const enabledKeys = new Set(enabledFields.map((f) => f.columnKey));
  if (enabledKeys.size === 0) return [];

  return (rowCards || [])
    .map((card) => ({
      ...card,
      fields: (card.fields || []).filter((f) => enabledKeys.has(f.columnKey))
    }))
    .filter((card) => card.fields?.length > 0);
}
